import React, { useState } from 'react';
import { Layout } from '../../components/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Button } from '../../components/ui/button';
import { Plus, Edit, Trash, PlayCircle, PauseCircle } from 'lucide-react';

export const Campaigns = () => {
  const campaigns = [
    { id: 1, name: 'Google Ads - Summer 2025', status: 'active', budget: 2000, spent: 750, leads: 5, platform: 'Google Ads', startDate: '2025-06-01', endDate: '2025-08-31' },
    { id: 2, name: 'Facebook Retargeting', status: 'active', budget: 1500, spent: 450, leads: 3, platform: 'Facebook', startDate: '2025-06-15', endDate: '2025-12-31' },
    { id: 3, name: 'Instagram Brand Awareness', status: 'paused', budget: 1000, spent: 200, leads: 1, platform: 'Instagram', startDate: '2025-05-01', endDate: '2025-07-31' },
    { id: 4, name: 'Local SEO Campaign', status: 'active', budget: 500, spent: 500, leads: 2, platform: 'Google', startDate: '2025-01-01', endDate: '2025-12-31' }
  ];

  const getStatusColor = (status) => {
    return status === 'active' ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' : 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200';
  };

  const formatCurrency = (value) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }).format(value);

  return (
    <Layout>
      <div className="p-6 space-y-6">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Campaigns</h1>
            <p className="text-gray-600 dark:text-gray-400">Manage and track marketing campaigns</p>
          </div>
          <Button><Plus className="h-4 w-4 mr-2" />New Campaign</Button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Card>
            <CardHeader className="pb-2">
              <CardTitle className="text-sm font-medium">Total Budget</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">{formatCurrency(campaigns.reduce((sum, c) => sum + c.budget, 0))}</div>
            </CardContent>
          </Card>
          <Card>
            <CardHeader className="pb-2">
              <CardTitle className="text-sm font-medium">Total Spent</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">{formatCurrency(campaigns.reduce((sum, c) => sum + c.spent, 0))}</div>
            </CardContent>
          </Card>
          <Card>
            <CardHeader className="pb-2">
              <CardTitle className="text-sm font-medium">Total Leads</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">{campaigns.reduce((sum, c) => sum + c.leads, 0)}</div>
            </CardContent>
          </Card>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Active Campaigns</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              {campaigns.map(campaign => (
                <div key={campaign.id} className="border rounded-lg p-4 hover:bg-gray-50 dark:hover:bg-gray-800">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <div className="flex items-center gap-3 mb-2">
                        <h3 className="font-semibold text-lg">{campaign.name}</h3>
                        <Badge className={getStatusColor(campaign.status)}>{campaign.status}</Badge>
                      </div>
                      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                        <div><span className="text-gray-600">Platform:</span> <span className="font-medium">{campaign.platform}</span></div>
                        <div><span className="text-gray-600">Budget:</span> <span className="font-medium">{formatCurrency(campaign.budget)}</span></div>
                        <div><span className="text-gray-600">Spent:</span> <span className="font-medium">{formatCurrency(campaign.spent)}</span></div>
                        <div><span className="text-gray-600">Leads:</span> <span className="font-medium">{campaign.leads}</span></div>
                      </div>
                      <div className="mt-2">
                        <div className="w-full bg-gray-200 rounded-full h-2">
                          <div className="bg-blue-600 h-2 rounded-full" style={{ width: `${(campaign.spent / campaign.budget) * 100}%` }}></div>
                        </div>
                        <p className="text-xs text-gray-500 mt-1">{((campaign.spent / campaign.budget) * 100).toFixed(0)}% of budget used</p>
                      </div>
                    </div>
                    <div className="flex gap-2 ml-4">
                      <Button variant="ghost" size="sm">{campaign.status === 'active' ? <PauseCircle className="h-4 w-4" /> : <PlayCircle className="h-4 w-4" />}</Button>
                      <Button variant="ghost" size="sm"><Edit className="h-4 w-4" /></Button>
                      <Button variant="ghost" size="sm"><Trash className="h-4 w-4" /></Button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};